import type { Tone } from '../../domain/types';

export type BadgeVariant = 'soft' | 'solid' | 'outline';

export interface BadgeToneColors {
  bg: string;
  text: string;
  dot: string;
}

function variantColors(
  solid: BadgeToneColors,
  outline: BadgeToneColors,
  soft: BadgeToneColors,
  variant: BadgeVariant,
): BadgeToneColors {
  if (variant === 'solid') return solid;
  if (variant === 'outline') return outline;
  return soft;
}

export function getToneColors(toneName: Tone, variantType: BadgeVariant): BadgeToneColors {
  if (toneName === 'ok') {
    return variantColors(
      { bg: 'var(--z-ok)', text: '#ffffff', dot: '#ffffff' },
      { bg: 'var(--z-ok-bg)', text: 'var(--z-ok)', dot: 'var(--z-ok)' },
      { bg: 'var(--z-ok-bg)', text: 'var(--z-ok-ink, var(--z-ok))', dot: 'var(--z-ok)' },
      variantType,
    );
  }
  if (toneName === 'warn') {
    return variantColors(
      { bg: 'var(--z-warn)', text: '#ffffff', dot: '#ffffff' },
      { bg: 'var(--z-warn-bg)', text: 'var(--z-warn)', dot: 'var(--z-warn)' },
      { bg: 'var(--z-warn-bg)', text: 'var(--z-warn-ink, var(--z-warn))', dot: 'var(--z-warn)' },
      variantType,
    );
  }
  if (toneName === 'bad') {
    return variantColors(
      { bg: 'var(--z-bad)', text: '#ffffff', dot: '#ffffff' },
      { bg: 'var(--z-bad-bg)', text: 'var(--z-bad)', dot: 'var(--z-bad)' },
      { bg: 'var(--z-bad-bg)', text: 'var(--z-bad-ink, var(--z-bad))', dot: 'var(--z-bad)' },
      variantType,
    );
  }
  if (toneName === 'accent') {
    return variantColors(
      { bg: 'var(--z-accent)', text: 'var(--z-on-accent)', dot: 'var(--z-on-accent)' },
      { bg: 'var(--z-accent-soft)', text: 'var(--z-accent)', dot: 'var(--z-accent)' },
      { bg: 'var(--z-accent-soft)', text: 'var(--z-accent-copy)', dot: 'var(--z-accent)' },
      variantType,
    );
  }
  return variantColors(
    { bg: 'var(--z-fill-2)', text: 'var(--z-text)', dot: 'var(--z-muted)' },
    { bg: 'var(--z-fill)', text: 'var(--z-text-2)', dot: 'var(--z-muted)' },
    { bg: 'var(--z-fill-2)', text: 'var(--z-muted-2)', dot: 'var(--z-dim)' },
    variantType,
  );
}
